module.exports = __webpack_public_path__ + "img/background.bb71d49d.jpg";